module.exports = __webpack_public_path__ + "media/images/contents/rich_message/no_image-fa55f36561ced5c9daf15e76678857ae.png";